import React, { useMemo } from "react";
import { ReactComponent as CalendarIcon } from "../../../../inlineSvgs/calendar-2.svg";
import { ReactComponent as ArrowIcon } from "../../../../inlineSvgs/arrow-right-2.svg";
import { Link } from "react-router-dom";
import { getTimeFromMins } from "../../../../config";

const SelectDate = ({ date, time, service }) => {
  const formattedDate = useMemo(() => {
    return new Date(date).toLocaleString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  }, [date]);

  return (
    <Link to="/booking/date" className="order-param">
      <CalendarIcon />
      {date && time ? (
        <div className="date-info info">
          <div className="title">{formattedDate}</div>
          <div className="sub-title">
            <span className="time">{`${time.hours} :  ${time.minutes === 0 ? "00" : time.minutes}`}</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none">
              <circle cx="2" cy="2" r="2" fill="#D6D6DB" />
            </svg>
            {service && <span className="duration">{getTimeFromMins(service.duration)} Hours</span>}
          </div>
        </div>
      ) : (
        <div className="not-info">
          <div className="title">Select Date & Time</div>
          <div className="sub-title">Choose date & time to book</div>
        </div>
      )}
      <ArrowIcon />
    </Link>
  );
};

export default SelectDate;
